// getters.js

export default {
    getPortList(state){
        return state.portList
    },
};
